<template>
  <div>
    <MenuCount_Stock/>
    <Count_barcode/>
  </div>
</template>

<script>
import Count_barcode from "@/components/admin/count_stock/Count_barcode";
import MenuCount_Stock from "@/components/admin/count_stock/menucount_stock/MenuCount_Stock";
export default {
  name: "CountBarcode",
  components: {
    MenuCount_Stock,
    Count_barcode
  }
}
</script>

<style scoped>

</style>
